<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>
<p-dialog header=" {{ cellValue[0].toUpperCase() }}" [modal]="true" [(visible)]="dialogVisible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
  <app-table [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="commentTable" [rows$]="comments$"
  [pageSize]="5"></app-table>
</p-dialog>
<div class="filter-dropdown-container-dis">

  <app-dropdown [options]="districtOptions" (selectedValueChange)="onDistrictChange($event)"
    customClass="districts-district-dropdown" [(selectedValue)]="selectedDistrict" placeholder="District"
    label="District" [showLabel]="false" aria-label="District" [showFloatingLabel]="true">
  </app-dropdown>

  <!-- <span class="p-float-label">
  <p-datepicker [showIcon]="true" class="calender-icon" [(ngModel)]="selectedScheduledDate"
    (onSelect)="onScheduledDateChange($event)" placeholder="Sched Date" inputId="icon" dateFormat="mm/dd/yy">
  </p-datepicker>
  <label style="display: block;font-size: 16px; color: rgb(33, 37, 41);">
    Sched Date
  </label>
</span> -->

<app-datepicker [(ngModel)]="selectedScheduledDate" (onSelectChange)="onScheduledDateChange($event)"
[inputlabel]="'Sched Date'"></app-datepicker>

<app-dropdown [options]="dispatchViewOptions" [(selectedValue)]="selectedDispatchView"
  (selectedValueChange)="onDispatchViewChange($event)" placeholder="Dispatch Status" aria-label="Dispatch Status"
  label="Dispatch Status" [showLabel]="false" customClass="districts-dispatch-dropdown-adjustment"
  [showFloatingLabel]="true">
</app-dropdown>

<app-dropdown [options]="typeOptions" [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)"
  placeholder="Type" label="Type" aria-label="Type" customClass="districts-small-dropdown-adjustment"
  [showLabel]="false" [showFloatingLabel]="true">
</app-dropdown>
<div>
  <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>
  <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
</div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" [totalRecords]="totalRecords" (onAction2ButtonClicked)="onReloadClicked()"
  (sortClicked)="onSortClicked($event)" (onSearchText)="onSearchText($event)" [actionButtons]="actionButtons"
(pageChanged)="onPageChanged($event)" (onCellClicked)="onCellClicked($event)"></app-table>